if (!customElements.get('quote-form-modal')) {
  customElements.define(
    'quote-form-modal',
    class QuoteFormModal extends DrawerComponent {
      connectedCallback() {
        super.connectedCallback();

        const form = this.querySelector('[data-quote-form]');
        const submitButton = this.querySelector('[data-quote-submit]');
        if (!form || !submitButton) return;

        submitButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          submitButton.disabled = true;

          fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
          })
            .then(() => {
              form.hidden = true;
              const successMessage = this.querySelector('[data-quote-success]');
              if (successMessage) {
                successMessage.hidden = false;
                successMessage.querySelector('h3')?.focus();
              }
            })
            .catch(() => {
              submitButton.disabled = false;
              alert('Something went wrong sending your request - please try again.');
            });
        });
      }
    }
  );
}
